import { Goal } from "@/types/goals";

export interface APIGoalFormat {
  minorAccountID: string;
  goalType: string;
  amountRequired: number;
  description: string;
  timeline: string;
}

export const transformGoalForAPI = (goal: Goal): APIGoalFormat => {
  const currentDate = new Date();
  const timeline = new Date(
    goal.year,
    currentDate.getMonth(),
    currentDate.getDate(),
  ).toISOString();

  return {
    minorAccountID: String(goal.beneficiaryId),
    goalType: goal.purpose,
    amountRequired: goal.amount,
    description: goal.purpose,
    timeline: timeline,
  };
};

export const transformGoalsForAPI = (goals: Goal[]): APIGoalFormat[] => {
  return goals.map((goal) => transformGoalForAPI(goal));
};
